'use strict';

require('@kadira/storybook-addon-actions/register');

require('@kadira/storybook-addon-links/register');


//////////////////
// WEBPACK FOOTER
// ./~/@kadira/storybook/dist/server/addons.js
// module id = 690
// module chunks = 0